module.exports = {"svg":{"$":{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"},"title":["UI_RightArrow_16"],"polygon":[{"$":{"points":"14 8 8 3 8 6 2 6 2 10 8 10 8 13 14 8","fill":"#464646"}}]}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/xml-loader!./src/svg/UI_RightArrow_16.svg
// module id = o4rv
// module chunks = 1